import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { API_URL, BASE_URL } from './Config';
import config from "./common/Config";
import "rsuite/Dropdown/styles/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "./css/header.css";
const Header = () => {
  const [activeLink, setActiveLink] = useState("Dashboard");
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [SiteName, setSiteName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showNotifications, setShowNotifications] = useState(false); // Toggle notification dropdown
  const [showProfileDropdown, setShowProfileDropdown] = useState(false); // Toggle profile dropdown
  const [notificationCount, setNotificationCount] = useState(4); // Placeholder for notification count
  const [notificationData, setNotificationData] = useState([]);
  const accessToken = localStorage.getItem("accessToken");
  const isSinglePicking = localStorage.getItem("isSinglePicking");
  const shopifyConnectivity = localStorage.getItem("shopifyConnectivity");
  const amazonConnectivity = localStorage.getItem("amazonConnectivity");
  const showEmailTemplate = localStorage.getItem("showEmailTemplate");
  const showContraPrice = localStorage.getItem("showContraPrice");
  const userId = localStorage.getItem("userId");
  const user_role = localStorage.getItem("user_role");
  const token = localStorage.getItem('token');
  const prefix = localStorage.getItem('accessToken');
  const username = localStorage.getItem('username');
  const navigate = useNavigate();
  const location = useLocation();
  console.log(user_role);
  if (accessToken == "ayt") {
    const pageTitle = "Southall";
  }
  if (accessToken == "dds") {
    const pageTitle = "DDsnack";
  } else {
    const pageTitle = "Ebusso";
  }

  useEffect(() => {
    // Retrieve the logo URL, first name, and last name from localStorage
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/react/login";
      return;
    }

    const userId = localStorage.getItem("userId");
    const site_name = localStorage.getItem("site_name");
    const storedFirstName = localStorage.getItem("first_name");
    const storedLastName = localStorage.getItem("last_name");

    if (site_name) {
      setSiteName(site_name);
    }
    if (storedFirstName) {
      setFirstName(storedFirstName);
    }
    if (storedLastName) {
      setLastName(storedLastName);
    }
  }, []);

  const handleSetActiveLink = (link) => {
    setActiveLink(link);
  };

  const handleMobileNavToggle = () => {
    setMobileNavOpen(!mobileNavOpen);
  };

  const handleLogout = () => {
     try {
    const apiBCUrl = `${config.API_URL}/ws-logout`;

    const formData = new FormData();
    formData.append("Platform", "Web");

    const response =  fetch(apiBCUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: formData,
    });

    if (!response.ok) {
      console.error("Logout API failed:",  response.text());
    }
  } catch (error) {
    console.error("Logout API error:", error);
  }
    localStorage.removeItem("site_name");
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_role");
    localStorage.removeItem("isSinglePicking");
    localStorage.removeItem("shopifyConnectivity");
    localStorage.removeItem("amazonConnectivity");
    localStorage.removeItem("showEmailTemplate");
    localStorage.removeItem("showContraPrice");
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("user_permissions");


    window.location.href = `${config.LOG_OUT}`;
  };

  // Toggle the notifications dropdown
  const toggleNotifications = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    setShowNotifications(!showNotifications);
    setShowProfileDropdown(false);
    // getNotificationData();
  };

  const getNotificationData = async () => {
    const apiBCUrl = `${config.API_URL}/ws-get-notification-data`;
    try {
      const response = await fetch(apiBCUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch notification list");
      }

      const data = await response.json();
      // console.log(data);
      setNotificationData(data.data);
    } catch (error) {
      console.log("Error fetch notification data", error);
    }
  };

  const toggleProfileDropdown = (e) => {
    e.stopPropagation();
    setShowProfileDropdown(!showProfileDropdown);
    setShowNotifications(false);
  };

  const handleClickOutside = (e) => {
    if (showNotifications && !e.target.closest(".notification-drop")) {
      setShowNotifications(false);
    }
    if (showProfileDropdown && !e.target.closest(".nav-profile")) {
      setShowProfileDropdown(false);
    }
  };

  useEffect(() => {
    // getNotificationData();
    // Close notification dropdown and profile dropdown when clicked outside
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showNotifications, showProfileDropdown]);
  const checkIfAlreadyLoggedIn = async () => {
    
    if (!userId || !prefix) return true; // allow if not logged in

    const checkFormData = new FormData();
    checkFormData.append('username', username);
    checkFormData.append('platform', 'web');
    if (token) checkFormData.append('token', token);

    try {
      const checkResponse = await fetch(`${config.API_URL}/ws-check-if-already-logged-in`, {
        method: 'POST',
        body: checkFormData,
      });
      const checkData = await checkResponse.json();
      if (checkData && checkData.success === true && checkData.lastLoginData && checkData.lastLoginData.jwtTokenWeb) {
        // If the token in localStorage does not match the server's lastLoginData.jwtToken, force logout
        if (token && token !== checkData.lastLoginData.jwtTokenWeb) {
          //Token mismatch, show alert and logout
          window.localStorage.clear();
          window.location.href = `${config.BASE_URL}/login`;
          return false;
        }
      }
      // If success false and message, also force logout
      // if (checkData && checkData.success === false && checkData.message) {
      //   window.localStorage.clear();
      //   window.location.href = `${config.BASE_URL}/login`;
      //   return false;
      // }
      return true;
    } catch (err) {
      // On error, allow access (or optionally force logout)
      return true;
    }
  };

  useEffect(() => {

    (async () => {
      const ok = await checkIfAlreadyLoggedIn();
      if (!ok) return;
      if (prefix) {
        localStorage.setItem("accessToken", prefix);
        localStorage.setItem("userId", userId);
        //fetchUserData();
      } else {
        window.location.href = `${config.LOG_OUT}`;
      }
    })();
  }, [prefix, userId]);
  //Code to open dropdown
  const [openDropdown, setOpenDropdown] = useState(null);
  const handleDropdownToggle = (dropdownName) => {
    // console.log("Current openDropdown:", openDropdown);
    // console.log("New dropdown to toggle:", dropdownName);
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };
  useEffect(() => {
    // console.log("Current openDropdown:", openDropdown);
  }, [openDropdown]);
  const userPermissions = JSON.parse(localStorage.getItem('user_permissions') || '[]');
  return (
    <header id="header" className="header fixed-top" data-scrollto-offset="0">
      <div className="container-fluid d-flex align-items-center justify-content-between">
        {user_role == 18 || user_role == 19 ? <>
          <span className="logo-area align-items-center scrollto me-auto me-lg-0">
            {SiteName}
          </span>
        </> : (
          <Link
            to={`/dashboard/${accessToken}/${userId}`}
            className="logo-area align-items-center scrollto me-auto me-lg-0"
          >
            {SiteName}
          </Link>
        )}
        {/* {user_role == 1 && (
          <Link
            to="/dashboard/company-settings"
            className={
              location.pathname === "/dashboard/company-settings" && "active"
            }
          >
            <span>Company Settings</span>
          </Link>
        )} */}
        {user_role == 1 && (
          <nav
            id="navbar"
            className={`navbar ${mobileNavOpen ? "mobile-nav-active" : ""}`}
          >
            <ul
              className={`nav-menu ${mobileNavOpen ? "mobile-nav-show" : ""}`}
            >
              <li>
                <Link
                  to={`/dashboard/${accessToken}/${userId}`}
                  onClick={() => handleSetActiveLink("Dashboard")}
                  className={
                    location.pathname ===
                    `/dashboard/${accessToken}/${userId}` && "active"
                  }
                >
                  <span>Dashboard</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard/company-settings"
                  className={
                    location.pathname === "/dashboard/company-settings" && "active"
                  }
                >
                  <span>Company Settings</span>
                </Link>
              </li>
            </ul>
          </nav>
        )}
        {(user_role == 8 || user_role == 20) && (
          <nav
            id="navbar"
            className={`navbar ${mobileNavOpen ? "mobile-nav-active" : ""}`}
          >
            <ul
              className={`nav-menu ${mobileNavOpen ? "mobile-nav-show" : ""}`}
            >
              <li>
                <Link
                  to={`/dashboard/${accessToken}/${userId}`}
                  onClick={() => handleSetActiveLink("Dashboard")}
                  className={
                    location.pathname ===
                    `/dashboard/${accessToken}/${userId}` && "active"
                  }
                >
                  <span>Dashboard</span>
                </Link>
              </li>
              {user_role == 1 && (
                <li>
                  <Link
                    to="/dashboard/company-settings"
                    className={
                      location.pathname === "/dashboard/company-settings" && "active"
                    }
                  >
                    <span>Company Settings</span>
                  </Link>
                </li>
              )}

              {(userPermissions.includes('NewSales') || userPermissions.includes('SalesHistory') || userPermissions.includes('SalesQuickOrder')) && (
                <li className="dropdown">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDropdownToggle("sales");
                    }}
                    className={openDropdown === "sales" ? "active" : ""}
                  >
                    <span>Sales</span>{" "}
                    <i className="bi bi-chevron-down dropdown-indicator"></i>
                  </a>
                  <ul className={openDropdown === "sales" ? "dropdown-active d-block" : "d-none"}>


                    {userPermissions.includes('NewSales') && (
                      <li>
                        <Link
                          to="/sales/newsales"
                          className={
                            location.pathname === "/sales/newsales" && "active"
                          }
                        >
                          <span>New Sales</span>
                        </Link>
                      </li>
                    )}

                    {/* <li><Link to="/sales/holdList" className={location.pathname === '/sales/holdList' && 'active'}><span>Hold List</span></Link></li> */}
                    {userPermissions.includes('SalesHistory') && (
                      <li>
                        <Link
                          to="/sales/shistory"
                          className={
                            location.pathname === "/sales/shistory" && "active"
                          }
                        >
                          <span>Order History</span>
                        </Link>
                      </li>
                    )}
                    {userPermissions.includes('SalesHistory') && (
                      <li>
                        <Link
                          to="/sales/reject_sales"
                          className={
                            location.pathname === "/sales/reject_sales" && "active"
                          }
                        >
                          <span>Reject Sales History</span>
                        </Link>
                      </li>
                    )}

                    {userPermissions.includes('SalesQuickOrder') && (
                      <li>
                        <Link
                          to="/sales/Quick_Order"
                          className={location.pathname === "/sales/Quick_Order" ? "active" : ""}
                        >
                          <span>Quick Order</span>
                        </Link>
                      </li>

                    )}

                    {user_role == 20 && (
                      <li>
                        <Link
                          to="/sales/epos_sales"
                          className={location.pathname === "/sales/epos_sales" ? "active" : ""}
                        >
                          <span>Epos Sales</span>
                        </Link>
                      </li>
                    )}



                    {/*<li><Link to="/sales/Common_Invoice" className={location.pathname === '/sales/Common_Invoice' && 'active'}><span>Common Invoice</span></Link></li>*/}
                    {/*    <li>
                    <Link
                      to="/sales/Epos"
                      className={
                        location.pathname === "/sales/Epos" && "active"
                      }
                    >
                      <span>Epos</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/sales/epos_sales"
                      className={
                        location.pathname === "/sales/epos_sales" && "active"
                      }
                    >
                      <span>Sales Report(Epos)</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/sales/Quick_Order"
                      className={
                        location.pathname === "/sales/Quick_Order" && "active"
                      }
                    >
                      <span>Quick Order</span>
                    </Link>
                  </li>*/ }
                  </ul>
                </li>

              )}
              <li className="dropdown">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("picking");
                  }}
                  className={openDropdown === "picking" ? "active" : ""}
                >
                  <span>Picking</span>{" "}
                  <i className="bi bi-chevron-down dropdown-indicator"></i>
                </a>
                <ul className={openDropdown === "picking" ? "dropdown-active d-block" : "d-none"}>

                  {userPermissions.includes('CreatePicking') && (
                    <li>
                      <Link
                        to="/picking/picking_create"
                        className={
                          location.pathname === "/picking/picking_create" &&
                          "active"
                        }
                      >
                        <span>Create Picking</span>
                      </Link>
                    </li>

                  )}

                  {userPermissions.includes('PickingList') && (
                    <li>
                      {isSinglePicking === 'Y' ? (
                        <Link
                          to="/picking/single_picking_list"
                          className={location.pathname === "/picking/single_picking_list" ? "active" : ""}
                        >
                          <span>Picking List</span>
                        </Link>
                      ) : (
                        <Link
                          to="/picking/picking_list"
                          className={location.pathname === "/picking/picking_list" ? "active" : ""}
                        >
                          <span>Picking List</span>
                        </Link>
                      )}
                    </li>
                  )}

                  {userPermissions.includes('PickingHistory') && (

                    <li>
                      <Link
                        to="/picking/picking_history"
                        className={
                          location.pathname === "/picking/picking_history" &&
                          "active"
                        }
                      >
                        <span>Picking History</span>
                      </Link>
                    </li>

                  )}

                  {userPermissions.includes('PickingHistory') && isSinglePicking === 'N' && (
                    <li>
                      <Link
                        to="/picking/short_qty"
                        className={location.pathname === "/picking/short_qty" ? "active" : ""}
                      >
                        <span>Short QTY</span>
                      </Link>
                    </li>
                  )}


                  {userPermissions.includes('ProformaInvoice') && (
                    <li>
                      <Link
                        to="/picking/proforma"
                        className={
                          location.pathname === "/picking/proforma" && "active"
                        }
                      >
                        <span>Confirm Picking</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>



              <li className="dropdown">
                <a
                  href="#"
                  // className={
                  //   (location.pathname === "/delivery/route_planing" ||
                  //     location.pathname === "/manifest_list" ||
                  //     location.pathname === "/open_trips" ||
                  //     location.pathname === "/complete_trips") &&
                  //   "active"
                  // }
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("delivery");
                  }}
                  className={openDropdown === "delivery" ? "active" : ""}
                >
                  <span>Dispatch & Deliveries</span>{" "}
                  <i className="bi bi-chevron-down dropdown-indicator"></i>
                </a>
                <ul className={openDropdown === "delivery" ? "dropdown-active d-block" : "d-none"}>


                  {userPermissions.includes('CreateManifest') && (
                    <li>
                      <Link
                        to="/delivery/route_planing"
                        className={
                          location.pathname === "/delivery/route_planing" &&
                          "active"
                        }
                      >
                        <span>Create Manifest</span>
                      </Link>
                    </li>
                  )}

                  {userPermissions.includes('CreateManifest') && (
                    <li>
                      <Link
                        to="/manifest_list"
                        className={
                          location.pathname === "/manifest_list" && "active"
                        }
                      >
                        <span>Manifest List</span>
                      </Link>
                    </li>
                  )}
                  {userPermissions.includes('Trip') && (
                    <li>
                      <Link
                        to="/open_trips"
                        className={
                          location.pathname === "/open_trips" && "active"
                        }
                      >
                        <span>Open Trip</span>
                      </Link>
                    </li>
                  )}

                  {userPermissions.includes('Trip') && (
                    <li>
                      <Link
                        to="/complete_trips"
                        className={
                          location.pathname === "/complete_trips" && "active"
                        }
                      >
                        <span>Complete Trip</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>

              <li className="dropdown">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("product-master");
                  }}
                  className={openDropdown === "product-master" ? "active" : ""}
                >
                  <span>Master</span>{" "}
                  <i className="bi bi-chevron-down dropdown-indicator"></i>
                </a>
                <ul className={openDropdown === "product-master" ? "dropdown-active d-block" : "d-none"}>
                  {userPermissions.includes('Product') && ( 
                    <li>
                      <Link
                        to="/products"
                        className={location.pathname === "/products" && "active"}
                      >
                        <span>Products</span>
                      </Link>
                    </li>
                  )}

                  {userPermissions.includes('ProductsPriceVariation') && (
                    <li>
                      <Link
                        to="/products_price_variation"
                        className={
                          location.pathname === "/products_price_variation" &&
                          "active"
                        }
                      >
                        <span>Product Price Variation</span>
                      </Link>
                    </li>
                  )}

                  {userPermissions.includes('Supplier') && (
                    <li>
                      <Link
                        to="/supplier"
                        className={location.pathname === "/supplier" && "active"}
                      >
                        <span>Suppliers</span>
                      </Link>
                    </li>
                  )}
                 {userPermissions.includes('Users') && ( 
                    <li>
                      <Link
                        to="/users"
                        className={location.pathname === "/users" && "active"}
                      >
                        <span>Users</span>
                      </Link>
                    </li>

                  )} 
                  {userPermissions.includes('ProductCategories') && (
                    <li>
                      <Link
                        to="/product_category"
                        className={
                          location.pathname === "/product_category" && "active"
                        }
                      >
                        <span>Product Categories</span>
                      </Link>
                    </li>

                  )}

                  {userPermissions.includes('Brand') && (
                    <li>
                      <Link
                        to="/Brands"
                        className={location.pathname === "/Brands" && "active"}
                      >
                        <span>Brands</span>
                      </Link>
                    </li>
                  )}
                  {userPermissions.includes('Unit') && (
                    <li>
                      <Link
                        to="/Units"
                        className={location.pathname === "/Units" && "active"}
                      >
                        <span>Units</span>
                      </Link>
                    </li>
                  )}

                  {userPermissions.includes('Customers') && (
                    <li>
                      <Link
                        to="/customers"
                        className={location.pathname === "/customers" && "active"}
                      >
                        <span>Customers</span>
                      </Link>
                    </li>
                  )}

                  {showContraPrice === 'Y' && (
                    <li>
                      <Link
                        to="/ContraList"
                        className={
                          location.pathname === "/ContraList" && "active"
                        }
                      >
                        <span>Contra Price Customers</span>
                      </Link>
                    </li>
                  )}
                  {/* <li>
                    <Link
                      to="/shopifyCategoryList"
                      className={
                        location.pathname === "/shopifyCategoryList" && "active"
                      }
                    >
                      <span>Shopify Category List</span>
                    </Link>
                  </li> */}
                  {shopifyConnectivity === 'Y' && (
                    <li>
                      <Link
                        to="/shopifyProductList"
                        className={
                          location.pathname === "/shopifyProductList" && "active"
                        }>
                        <span>Shopify Product List</span>
                      </Link>
                    </li>
                  )}
                  {amazonConnectivity === 'Y' && (  
                    <li>
                      <Link
                        to="/amazonProductList"
                        className={
                          location.pathname === "/amazonProductList" && "active"
                        }>
                        <span>Amazon Product List</span>
                      </Link>
                    </li>
                   )} 
                </ul>
              </li>

              <li className="dropdown">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("reports");
                  }}
                  className={openDropdown === "reports" ? "active" : ""}
                >
                  <span>Report</span>{" "}
                  <i className="bi bi-chevron-down dropdown-indicator"></i>
                </a>
                <ul className={`reports-menu ${openDropdown === "reports" ? "dropdown-active d-block" : "d-none"}`}>

                  {/* Sales Category */}
                  <li className="dropdown">
                    <a href="#" className="category-trigger">
                      <span>Sales</span>
                      <i className="bi bi-chevron-right category-arrow"></i>
                    </a>
                    <ul className="horizontal-submenu">
                      <li>
                        <Link
                          to="/reports/sales_report"
                          className={location.pathname === "/reports/sales_report" ? "active" : ""}
                        >
                          <span>Sales Rep Report</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/inventory_sales_report"
                          className={location.pathname === "/reports/inventory_sales_report" ? "active" : ""}
                        >
                          <span>Inventory Sales Report</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/sales_product_report"
                          className={location.pathname === "/reports/sales_product_report" ? "active" : ""}
                        >
                          <span>Sales Products Report</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/customer_not_order_report"
                          className={location.pathname === "/reports/customer_not_order_report" ? "active" : ""}
                        >
                          <span>Customer Not Order</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/dsr_report"
                          className={location.pathname === "/reports/dsr_report" ? "active" : ""}
                        >
                          <span>DSR Report</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/DaySummaryReport"
                          className={
                            location.pathname === "/reports/DaySummaryReport" && "active"
                          }
                        >
                          <span>Day Summary Report</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/SalesOrderReport"
                          className={
                            location.pathname === "/reports/SalesOrderReport" && "active"
                          }
                        >
                          <span>Sales Order Report</span>
                        </Link>
                      </li>

                    </ul>
                  </li>

                  {/* Account Category */}
                  <li className="dropdown">
                    <a href="#" className="category-trigger">
                      <span>Account</span>
                      <i className="bi bi-chevron-right category-arrow"></i>
                    </a>
                    <ul className="horizontal-submenu">
                      <li>
                        <Link
                          to="/reports/profit_loss_report"
                          className={location.pathname === "/reports/profit_loss_report" ? "active" : ""}
                        >
                          <span>Profit and Loss</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/TransactionsReport"
                          className={location.pathname === "/reports/TransactionsReport" ? "active" : ""}
                        >
                          <span>Transaction Report</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/mis_report"
                          className={location.pathname === "/reports/mis_report" ? "active" : ""}
                        >
                          <span>MIS Order Wise</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/mis_product_report"
                          className={location.pathname === "/reports/mis_product_report" ? "active" : ""}
                        >
                          <span>MIS Product Wise</span>
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Inventory Category */}
                  <li className="dropdown">
                    <a href="#" className="category-trigger">
                      <span>Inventory</span>
                      <i className="bi bi-chevron-right category-arrow"></i>
                    </a>
                    <ul className="horizontal-submenu">
                      <li>
                        <Link
                          to="/reports/stock_report"
                          className={location.pathname === "/reports/stock_report" ? "active" : ""}
                        >
                          <span>Stock Report</span>
                        </Link>
                      </li>
                       <li>
                        <Link
                          to="/reports/batchWise_stock_report"
                          className={location.pathname === "/reports/batchWise_stock_report" ? "active" : ""}
                        >
                          <span>Batch Wise Stock Report</span>
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Other Category */}
                  <li className="dropdown">
                    <a href="#" className="category-trigger">
                      <span>Other</span>
                      <i className="bi bi-chevron-right category-arrow"></i>
                    </a>
                    <ul className="horizontal-submenu">
                      <li>
                        <Link
                          to="/reports/missing_order"
                          className={location.pathname === "/reports/missing_order" ? "active" : ""}
                        >
                          <span>Cross Off Report</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/reports/lat_long_report"
                          className={location.pathname === "/reports/lat_long_report" ? "active" : ""}
                        >
                          <span>Order Location Report</span>
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="dropdown">
                    <a href="#" className="category-trigger">
                      <span>Purchase</span>
                      <i className="bi bi-chevron-right category-arrow"></i>
                    </a>
                    <ul className="horizontal-submenu">
                      <li>
                        <Link
                          to="/reports/PurchaseOrderReport"
                          className={
                            location.pathname === "/reports/PurchaseOrderReport" ? "" : ""
                          }
                        >
                          <span>Purchase Report</span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li className="dropdown">
                <a
                  href="#"
                  // className={
                  //   (location.pathname === "/purchases/purchases_order" ||
                  //     location.pathname === "/purchases/add" ||
                  //     location.pathname === "/purchases/purchases_grn" ||
                  //     location.pathname === "/purchases/AddPurchasesGRN" || location.pathname === "/purchases/StockAdjustment") &&
                  //   "active"
                  // }
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("purchases");
                  }}
                  className={openDropdown === "purchases" ? "active" : ""}
                >
                  <span>Purchases</span>{" "}
                  <i className="bi bi-chevron-down dropdown-indicator"></i>
                </a>
                <ul className={openDropdown === "purchases" ? "dropdown-active d-block" : "d-none"}>

                  {userPermissions.includes('PurchasesOrder') && (
                    <li>
                      <Link
                        to="/purchases/purchases_order"
                        className={
                          location.pathname === "/purchases/purchases_order" &&
                          "active"
                        }
                      >
                        <span>Purchases Order</span>
                      </Link>
                    </li>
                  )}
                  {userPermissions.includes('PurchasesHistory') && (
                    <li>
                      <Link
                        to="/purchases/purchases_grn"
                        className={
                          location.pathname === "/purchases/purchases_grn" &&
                          "active"
                        }
                      >
                        <span>Purchases History</span>
                      </Link>
                    </li>
                  )}
                  {userPermissions.includes('StockAdjustment') && (
                    <li>
                      <Link
                        to="/purchases/StockAdjustment"
                        className={
                          location.pathname === "/purchases/StockAdjustment" &&
                          "active"
                        }
                      >
                        <span>Stock Adjustment</span>
                      </Link>
                    </li>
                  )}
                  <li>
                    {/*   <Link
                      to="/purchases/suggested"
                      className={
                        location.pathname === "/purchases/suggested" &&
                        "active"
                      }>
                      <span>Suggested PO</span>
                    </Link> */}
                  </li>
                </ul>
              </li>
              <li className="dropdown">
                <a
                  href="#"
                  // className={
                  //   (location.pathname === "/account/push_sage" ||
                  //     location.pathname === "/account/push_invoice" ||
                  //     location.pathname === "/account/payments" ||
                  //     location.pathname === "/account/customer_accounts" ||
                  //     location.pathname === "/account/supplier_ledger" ||
                  //     location.pathname === "/account/payment_ladger" ||
                  //     location.pathname === "/account/my_ledger" ||
                  //     location.pathname === "/account/product_ledger" ||
                  //     location.pathname === "/account/bank_ledger") &&
                  //   "active"
                  // }
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("account");
                  }}
                  className={openDropdown === "account" ? "active" : ""}
                >
                  <span>Account</span>{" "}
                  <i className="bi bi-chevron-down dropdown-indicator"></i>
                </a>
                <ul className={openDropdown === "account" ? "dropdown-active d-block" : "d-none"}>

                  {accessToken === "dds" && (
                    <li>
                      <Link
                        to="/account/push_sage"
                        className={
                          location.pathname === "/account/push_sage" && "active"
                        }
                      >
                        <span>Push to Sage</span>
                      </Link>
                    </li>
                  )}

                  {userPermissions.includes('ReceivedPayments') && (
                    <li>
                      <Link
                        to="/account/payments"
                        className={
                          location.pathname === "/account/payments" && "active"
                        }
                      >
                        <span>Received Payments</span>
                      </Link>
                    </li>
                  )}
                  {userPermissions.includes('CustomerAccount') && (
                    <li>
                      <Link
                        to="/account/customer_accounts"
                        className={
                          location.pathname === "/account/customer_accounts" &&
                          "active"
                        }
                      >
                        <span>Customer Accounts</span>
                      </Link>
                    </li>

                  )}
                  <li>
                    <Link
                      to="/account/supplier_ledger"
                      className={
                        location.pathname === "/account/supplier_ledger" &&
                        "active"
                      }
                    >
                      <span>Supplier Ledger</span>
                    </Link>
                  </li>
                  {userPermissions.includes('PaymentLedger') && (
                    <li>
                      <Link
                        to="/account/payment_ladger"
                        className={
                          location.pathname === "/account/payment_ladger" &&
                          "active"
                        }
                      >
                        <span>Payment Ledger</span>
                      </Link>
                    </li>
                  )}
                  {userPermissions.includes('PaymentLedger') && (
                    <li>
                      <Link
                        to="/account/my_ledger"
                        className={
                          location.pathname === "/account/my_ledger" && "active"
                        }
                      >
                        <span>My Ledger</span>
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      to="/account/product_ledger"
                      className={
                        location.pathname === "/account/product_ledger" &&
                        "active"
                      }
                    >
                      <span>Product Ledger</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/reports/payment_collection"
                      className={
                        location.pathname === "/reports/payment_collection" && "active"
                      }
                    >
                      <span>Payment Collected</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/stock_take/history"
                      className={
                        location.pathname === "/stock_take/history" && "active"
                      }
                    >
                      <span>Stock Take</span>
                    </Link>
                  </li>

                  {/* <li>
        <Link to="/account/bank_ledger" className={location.pathname === '/account/bank_ledger' && 'active'}>
        <span>Bank Ledger</span>
        </Link>
                                </li>*/}
                </ul>
              </li>
              <li className="dropdown">
                <a
                  href="#"
                  // className={
                  //   (location.pathname === "/return_list" ||
                  //     location.pathname === "/return/add_return") &&
                  //   "active"
                  // }
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("return");
                  }}
                  className={openDropdown === "return" ? "active" : ""}
                >
                  <span>Return</span>{" "}
                  <i className="bi bi-chevron-down dropdown-indicator"></i>
                </a>
                <ul className={openDropdown === "return" ? "dropdown-active d-block" : "d-none"}>
                  <li>
                    <Link
                      to="/return_list"
                      className={
                        location.pathname === "/return_list" && "active"
                      }
                    >
                      <span>Return List</span>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="dropdown">
                <a
                  href="#"
                  // className={
                  //   (location.pathname === "/Catalogue" ||
                  //     location.pathname === "/slider_settings" ||
                  //     location.pathname === "/stock_take/history" ||
                  //     location.pathname === "/stock_take/start_stock_take" ||
                  //     location.pathname === "/stock_take/stock_take_list" ||
                  //     location.pathname ===
                  //     "/stock_take/show_history_of_stock_take_list" ||
                  //     location.pathname === "/Promotions/Promos" ||
                  //     location.pathname === "/Promotions/Add_Promos" ||
                  //     location.pathname === "/Promotions/Edit_Promos" ||
                  //     location.pathname === "/Settings/Group_Permissions" ||
                  //     location.pathname === "/Settings/Change_Permissions" ||
                  //     location.pathname === "/settings/Application_Setting" ||
                  //     location.pathname === "/settings/Registration") &&
                  //   "active"
                  // }
                  onClick={(e) => {
                    e.preventDefault();
                    handleDropdownToggle("Promotions");
                  }}
                  className={openDropdown === "Promotions" ? "active" : ""}
                >
                  <span>Promotion</span>{" "}
                  <i className="bi bi-chevron-down dropdown-indicator"></i>
                </a>
                <ul className={openDropdown === "Promotions" ? "dropdown-active d-block" : "d-none"}>
                  {(accessToken != "eve" && accessToken != "ve" && accessToken != "ayt") && (
                    <li>
                      <Link
                        to="/Catalogue"
                        className={location.pathname === "/Catalogue" && "active"}
                      >
                        <span>Catalogue</span>
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      to="/slider_settings"
                      className={
                        location.pathname === "/slider_settings" && "active"
                      }
                    >
                      <span>Slider Settings</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Promotions/Promos"
                      className={
                        location.pathname === "/Promotions/Promos" && "active"
                      }
                    >
                      <span>Promotions</span>
                    </Link>
                  </li>
                  {showEmailTemplate === 'Y' && (
                    <li>
                      <Link
                        to="/emailTemplate"
                        className={
                          location.pathname === "/emailTemplate" && "active"
                        }
                      >
                        <span>Email Template</span>
                      </Link>
                    </li>
                  )}

                  {/*  <li><Link to="/Settings/Group_Permissions" className={location.pathname === '/Settings/Group_Permissions' && 'active'}><span> Group Permissions</span></Link></li>
        <li><Link to="/settings/Application_Setting" className={location.pathname === '/settings/Application_Setting' && 'active'}><span> Application Setting</span></Link></li>
        <li><Link to="/settings/Registration" className={location.pathname === '/settings/Registration' && 'active'}><span> Registration</span></Link></li>*/}
                </ul>
              </li>
            </ul>
            <i
              className="mobile-nav-toggle bi bi-list"
              onClick={handleMobileNavToggle}
            ></i>
          </nav>
        )}

        {user_role == 19 && (
          <nav
            id="navbar"
            className={`navbar ${mobileNavOpen ? "mobile-nav-active" : ""}`}
          >
            <ul
              className={`nav-menu ${mobileNavOpen ? "mobile-nav-show" : ""}`}
            >
              <li>
                <Link
                  to={`/sales/IncompleteOrderList`}
                  className={
                    location.pathname === `/sales/IncompleteOrderList/${accessToken}/${userId}` ||
                      location.pathname === '/sales/IncompleteOrderList'
                      ? "active"
                      : ""
                  }
                >
                  <span>Incomplete Order List</span>
                </Link>
              </li>
              <li>
                <Link
                  to={`/sales/InventoryReport`}
                  className={
                    location.pathname === `/sales/InventoryReport/${accessToken}/${userId}` ||
                      location.pathname === '/sales/InventoryReport'
                      ? "active"
                      : ""
                  }
                >
                  <span>Inventory Report</span>
                </Link>
              </li>
              <li>
                <Link
                  to={`/sales/epos_sales`}
                  className={
                    location.pathname === `/sales/epos_sales/${accessToken}/${userId}` ||
                      location.pathname === '/sales/epos_sales'
                      ? "active"
                      : ""
                  }
                >
                  <span>Sales Report</span>
                </Link>
              </li>
            </ul>
          </nav>
        )}

        {user_role == 18 && (
          <nav
            id="navbar"
            className={`navbar ${mobileNavOpen ? "mobile-nav-active" : ""}`}
          >
            <ul
              className={`nav-menu ${mobileNavOpen ? "mobile-nav-show" : ""}`}
            >
              <li>
                <Link
                  to="/sales/Epos"
                  className={
                    location.pathname ===
                      'sales/Epos' ? "active" : ""
                  }
                >
                  <span>Epos</span>
                </Link>
              </li>
              <li>
                <Link
                  to={`/sales/InventoryReport`}
                  className={
                    location.pathname === `/sales/InventoryReport/${accessToken}/${userId}` ||
                      location.pathname === '/sales/InventoryReport'
                      ? "active"
                      : ""
                  }
                >
                  <span>Inventory Report</span>
                </Link>
              </li>

              <li>
                <Link
                  to={`/sales/epos_sales`}
                  className={
                    location.pathname === `/sales/epos_sales/${accessToken}/${userId}` ||
                      location.pathname === '/sales/epos_sales'
                      ? "active"
                      : ""
                  }
                >
                  <span>Sales Report</span>
                </Link>
              </li>
            </ul>
          </nav>
        )}

        <div className="header-nav ms-auto">
          <ul className="d-flex align-items-center">
            {/*   <li className="nav-item dropdown">
              <a
                className={`nav-link nav-icon ${showNotifications ? "active" : ""
                  }`}
                onClick={toggleNotifications}
              >
                <i class="bi bi-bell"></i>
                <span class="badge bg-primary badge-number">
                  {notificationData?.length}
                </span>
              </a>
              <ul class="notification-drop notie">
                <li>
                
                  {showNotifications && (
                    <div
                      style={{ height: "300px", overflowY: "scroll" }}
                      id="style-3"
                    >
                      <ul className="dropdown notification-list">
                        {notificationData.map((item, index) => {
                          if (item.status === "expirePromo") {
                            const formattedDate = new Date(
                              item.expDate
                            ).toLocaleDateString("en-GB");
                            return (
                              <li key={index}>
                                <div className="notidetail">
                                  <div>
                                    <i className="bi bi-exclamation-circle text-warning"></i>
                                  </div>
                                  <div className="notdiscription">
                                    <p>Promotion expired</p>
                                    <h4>{item.productName}</h4>
                                    <p>{formattedDate}</p>
                                  </div>
                                </div>
                              </li>
                            );
                          } else {
                            return (
                              <li key={index}>
                                <div className="notidetail">
                                  <div>
                                    <i className="bi bi-exclamation-circle text-warning"></i>
                                  </div>
                                  <div className="notdiscription">
                                    <p>Product is below minimum quantity</p>
                                    <h4>{item.productName}</h4>
                                    <p className="currectstk">
                                      Current Stock : {parseInt(item.qty)}
                                    </p>
                                  </div>
                                </div>
                              </li>
                            );
                          }
                        })}
                      </ul>
                    </div>
                  )}
                </li>
              </ul>
            </li>  */}


            <li className="nav-item dropdown pe-3">
              <a
                className="nav-link nav-profile d-flex align-items-center pe-0"
                href="#"
                onClick={toggleProfileDropdown}
              >
                <span className="d-none d-md-block dropdown-toggle ps-2">
                  {firstName} {lastName ? lastName : ""}
                </span>
              </a>
              <ul
                className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow profile ${showProfileDropdown ? "active" : ""
                  }`}
              >
                {/* <li className="dropdown-header">
                  <h6>
                    {firstName} {lastName ? lastName : ""}
                  </h6> 
                </li> */}

                <li>
                  <Link className="dropdown-header" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right"></i>
                    <span>Sign Out</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
